<assessment-result subTitle="UNKNOWN_TITLE"
                   imageName="no_clue.svg">
</assessment-result>
<section class="layout-content mt" style="flex-direction: column; align-items: center">
  <p>{{'UNKNOWN_DESCRIPTION'  | translate}}&nbsp;</p>
  <ul>
    <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_1' | translate"></span></li>
    <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_2' | translate"></span></li>
    <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_3' | translate"></span></li>
    <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_4' | translate"></span></li>
    <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_5' | translate"></span></li>
  </ul>
</section>
<section class="layout-content">
  <take-picture titleBtn="PHOTO_TAKE_RETRY" [isWide]="true" [isDisabled]="isInProgress"
                (photoChange)="onPhotoChange($event)"></take-picture>
</section>
<section class="layout-content mt">
  <text-with-link linkText="BOOKING_CREATE_WORKSHOP_FORCE"
                  (clickChange)="onWebbookingNavigate()"></text-with-link>
</section>
